import { apiRequest } from '../../../shared/services/apiClient';
import {
  normalizeConversationAiOperation,
  type ConversationAiOperationItem,
} from '../../conversations/services/conversationService';

export type TenantAiOperationsPage = {
  items: ConversationAiOperationItem[];
  hasMore: boolean;
  nextBefore?: string;
};

export type ListTenantAiOperationsOptions = {
  limit?: number;
  before?: string;
  after?: string;
  status?: string;
  plugin?: string;
  triggeredBy?: string;
  functionName?: string;
  conversationId?: string;
  runId?: string;
  search?: string;
};

export const listTenantAiOperations = async (
  options: ListTenantAiOperationsOptions = {},
): Promise<TenantAiOperationsPage> => {
  const query = new URLSearchParams();

  if (typeof options.limit === 'number' && options.limit > 0) {
    query.set('limit', String(options.limit));
  }

  if (options.before?.trim()) {
    query.set('before', options.before.trim());
  }

  if (options.after?.trim()) {
    query.set('after', options.after.trim());
  }

  if (options.status?.trim()) {
    query.set('status', options.status.trim());
  }

  if (options.plugin?.trim()) {
    query.set('plugin', options.plugin.trim());
  }

  if (options.triggeredBy?.trim()) {
    query.set('triggeredBy', options.triggeredBy.trim());
  }

  if (options.functionName?.trim()) {
    query.set('functionName', options.functionName.trim());
  }

  if (options.conversationId?.trim()) {
    query.set('conversationId', options.conversationId.trim());
  }

  if (options.runId?.trim()) {
    query.set('runId', options.runId.trim());
  }

  if (options.search?.trim()) {
    query.set('search', options.search.trim());
  }

  const suffix = query.size > 0 ? `?${query.toString()}` : '';
  const payload = await apiRequest<any>(`/api/v1/ai/operations${suffix}`);

  return {
    items: Array.isArray(payload?.items) ? payload.items.map(normalizeConversationAiOperation) : [],
    hasMore: Boolean(payload?.hasMore),
    nextBefore: payload?.nextBefore ? String(payload.nextBefore) : undefined,
  };
};
